import React from 'react';
import './Send-Button.css'

const SendButton = (props) => {    
  return (
    <div>
     <div className="text-center mb-3 mb-md-2 mt-5 mt-md-0">
     {
      (props.buttonText==='Send OTP') ? 
      <button onClick={props.sendCredentials} disabled={ props.buttonText === "Send OTP" && props.selectedCheckboxes.length === 0 } type="submit" className="btn form-control send-button"> {props.buttonText}</button>:
      <button data-testid="sendButton" onClick={props.getPassword} disabled={!props.username.length} type="submit" className="btn form-control send-button"> {props.buttonText}</button>    
     }
     </div>
    </div>
  )
}

export default SendButton